export const dashboard = {
  stats: {
    total: 0,
    week: 0,
    pending_orders: 0,
    fulfilled_orders: 0
  },
  statsActions: {
    isLoading: false,
    error: ""
  },
  ordersActions: {
    isLoading: false,
    error: ""
  },
  pendingOrders: {},
  filterValues: {
    merchant: {},
    store: {}
  }
};

export const merchant = {
  merchants: [],
  selectedMerchant: {},
  isLoading: false,
  error: ""
};

export const store = {
  stores: [],
  selectedStore: {},
  isLoading: true,
  error: ""
};

export const product = {
  products: [],
  isLoading: true,
  error: "",
  product: { images: [] },
  filterValues: {
    merchant: {},
    store: {},
    search: "",
    pageSize: 30,
    stock_status: {
      value: null,
      label: "Todas"
    }
  },
  categories: []
};

export const order = {
  orders: {
    results: []
  },
  ordersActions: {
    isLoading: false,
    error: ""
  },
  orderActions: {
    isLoading: false,
    error: ""
  },
  order: {
  },
  selectedOrders: [],
  selectedProducts: [],
  filterValues: {
    merchant: {},
    store: {},
    search: "",
    end: null,
    start: null,
    pageSize: 30,
    sortBy: {
      value: null,
      label: "Mayor"
    },
    orderShippingType: {
      value: null,
      label: "Todos"
    },
    status: {
      value: null,
      label: "Todas"
    },
    paymentStatus: {
      value: null,
      label: "Todas"
    }
  }
};


export const remitter = {
  remitter: {},
  filterParams: {
    search: "",
    page: null
  },
  recoveryPasswordLink: "",
  recoveryPasswordActions: {
    isLoading: false,
    email: ""
  },
  isLoading: false,
  error: ""
};
